import React, { useContext, useMemo, useState } from "react";
import { AuthContext, useIsGuest } from "../login/AuthContext";
import { Account } from "../models/Account";
import { useFranchiseTags } from "./tag-context";
import { Tag } from "./tags-api";

export function TagDisplay({tags, selected}:{tags:Tag[], selected:number[]}){
    const myTags = useMemo(()=>tags.filter(t => selected.includes(t.id)), [tags, selected])
    if(myTags.length == 0)
        return null;
    return <span className="tag-list d-flex flex-wrap gap-2">
        {myTags.map(t => <span key={t.id} className={`badge bg-${t.color} text-truncate`} style={{maxWidth:"100px"}}>{t.name}</span>)}
    </span>
}

export function ColorTagDisplay({tags, selected}:{tags:Tag[], selected:number[]}){
    const myTags = useMemo(()=>tags.filter(t => selected.includes(t.id)), [tags, selected])
    if(myTags.length == 0)
        return null;
    return <span className="tag-list d-flex gap-1" title={myTags.map(a => a.name).join(', ')}>
        {myTags.map(t => <span key={t.id} className={`badge bg-${t.color} mt-2`} style={{minWidth:"25px", minHeight:"5px", maxHeight:"5px"}}>&nbsp;</span>)}
    </span>
}

export function AccountTags({account, mode="normal"}:{account:Account, mode?: "short" | "normal"}){
    const tags = useFranchiseTags(account.franchise);
    const isGuest = useIsGuest();
    if(isGuest) return null;
    if(!account.tags || account.tags.length == 0) return null;
    return mode == 'short' ? <ColorTagDisplay tags={tags} selected={account.tags} /> :
        <><br />
        <TagDisplay tags={tags} selected={account.tags} /></>

}